import dayjs from "dayjs"
import { AutocompleteType ,TextFieldType,DatePickerType} from "../../../../../../src/utilis/component/CustomFormElement"


type SocialHistoryFormType={
    category:AutocompleteType,
    description:AutocompleteType,
    quantity:AutocompleteType,
    status:AutocompleteType,   
    fromDate:DatePickerType,
    toDate:DatePickerType,
    notes:TextFieldType
}

export const socialHistoryform:SocialHistoryFormType={

    category:{
            element:"autocomplete",
            name:"category",
            fieldProps:{label:"Category"},
            rules:{required:"Category Required"},
            autocompleteProps: {
                getOptionLabel: (option) => option.name,
                isOptionEqualToValue: (option, value) => option.id == value.id,
              }
    },
    description:{
        element: "autocomplete",
        name: "description",
        fieldProps: {label: "Description"},
        rules: {required: "Description required"},
        autocompleteProps: {
            getOptionLabel: (option) => option.snomedDescription,
            isOptionEqualToValue: (option, value) => option.snomedId == value.snomedId,
          }
    },
    quantity:{
        element: "autocomplete",
        name: "quantity",
        fieldProps: {label: "Quantity"},
        rules:{required:false},
        autocompleteProps: {
            getOptionLabel: (option) => option.quantityDesc,
            isOptionEqualToValue: (option, value) => option.quantityId == value.quantityId,
          }
    },
    status:{
        element:"autocomplete",
        name:"status",
        fieldProps:{label:"Status"},
        rules:{required:false},
        autocompleteProps: {
            getOptionLabel: (option) => option.description,
            isOptionEqualToValue: (option, value) => option.id == value.id,
          }
},
fromDate:{
    element: "datepicker",
    name: "fromDate",
    fieldProps: { label: "From Date", type: 'date' },
    rules: { required: false },
    dateFormat: "DD-MM-YYYY",
    calenderProps:{maxDate:dayjs()}
},
toDate:{
    element: "datepicker",
    name: "toDate",
    fieldProps: { label: "To Date", type: 'date' },
    rules: { required: false },
    dateFormat: "DD-MM-YYYY"
},
notes:{
    element: "input",
    name: "notes",
    fieldProps: {label: "Notes",type:'text'},
    rules:{required:false}
},




}
